import React, { useState } from "react";
import { OttFaqs } from "../../../components/faqData.js";
import ContactUs from "../../../components/ContactUs.js";
import { Helmet } from "react-helmet-async";

const StreamingPlatfom = () => {
  const [actIndex, setActIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActIndex(index === actIndex ? null : index);
  };
  const scrollToContact = () => {
    document
      .getElementById("contact-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="India’s leading Streaming Platform Development Company, Ayanshtech Solutions — Get custom OTT and live streaming apps developed today!"
        />
        <meta name="copyright" content="codeglim" />
        <meta
          property="og:title"
          content="Streaming Platform Development company in india | Ayanshtech Solutions"
        />
        <meta property="og:site_name" content="Ayanshtech Solutions" />
        <meta
          property="og:url"
          content="https://ayanshtechnology.com/streaming-platform"
        />
        <meta
          property="og:description"
          content="India’s leading Streaming Platform Development Company, Ayanshtech Solutions — Get custom OTT and live streaming apps developed today!"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@Ayanshtech Solutions" />
        <meta
          name="twitter:title"
          content="Streaming Platform Development company in india | Ayanshtech Solutions"
        />
        <meta
          name="twitter:description"
          content="India’s leading Streaming Platform Development Company, Ayanshtech Solutions — Get custom OTT and live streaming apps developed today!"
        />
        <meta
          name="twitter:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <link
          rel="canonical"
          href="https://ayanshtechnology.com/streaming-platform"
        />
        <title>
          Streaming Platform Development company in india | Ayanshtech Solutions
        </title>
      </Helmet>
      <div className=" flex flex-col items-center justify-center p-6 gradient-background">
        <div className="  w-full">
          <div className="flex flex-col lg:flex-row items-center lg:space-x-16 ">
            <div className="lg:w-3/4 lg:text-left p-4 mt-10">
              <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
                Streaming Platform Development Company in India
              </h1>

              <p className="sm:text-base md:text-lg lg:text-lg mb-3">
                In today’s fast-evolving digital world, streaming technology is
                redefining how people watch, listen, and engage with content. As
                a leading Streaming Platform Development Company in India,
                Ayanshtech specializes in building powerful, scalable, and
                user-centric streaming platforms that deliver unmatched
                performance and reliability. Whether you’re launching a
                video-on-demand (VoD) service, live streaming platform, or music
                streaming app, we design and develop end-to-end solutions that
                combine smooth playback, adaptive quality, and secure content
                delivery — ensuring a flawless experience for your audience. Our
                Streaming Platform Development Expertise
              </p>

              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                Custom Architecture Design: Scalable and optimized for
                performance. Cloud Integration & Real-Time Streaming: Ensuring
                uninterrupted viewing across devices. Content Delivery
                Optimization: Low latency, adaptive bitrate, and seamless
                playback. Front-End & UI/UX Design: Engaging interfaces crafted
                for web, mobile, and smart TVs.
              </p>

              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                Secure Streaming Solutions: DRM implementation and CDN
                integration for content protection and global reach. At
                Ayanshtech, we leverage the latest technologies and frameworks
                to build next-generation streaming platforms that meet industry
                standards and user expectations. From concept to deployment, our
                team focuses on delivering a smooth, immersive, and high-quality
                streaming experience that drives engagement and growth.
              </p>

              <button
                onClick={scrollToContact}
                className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold py-2 px-4 rounded-full mt-6"
              >
                Get Started
              </button>
            </div>

            <div className="flex justify-center mb-12 lg:mb-0">
              <img
                src="\assets\images\devops\streamImg1.avif"
                alt="Streaming Platform Development Company in India"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>
          </div>
        </div>
        <div className="text-center mb-5 mt-10">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Key Features of Streaming Platform Solutions
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Our streaming platform solutions are designed to deliver seamless
            content delivery, high-quality playback, and exceptional user
            experiences. Explore the features that set our streaming platforms
            apart and enable you to engage audiences worldwide effectively.
          </p>
        </div>

        <div className=" p-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon10.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">High-Quality Playback</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Adaptive Streaming</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Content Security (DRM)</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">CDN Integration</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon6.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Multi-Device Support</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon5.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Live Streaming</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon4.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">User Analytics</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon3.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Scalable Infrastructure</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon2.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Offline Access</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon1.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Monetization Options</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon11.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Real-Time Chat</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon12.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Personalized Recommendations</p>
            </div>
          </div>
        </div>

        <div className="text-center  mt-20">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Enhance Your Streaming Platform with Cutting-Edge Solutions
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Elevate your streaming experience with innovative features designed
            for smooth performance, exceptional user experiences, and robust
            scalability.
          </p>
        </div>

        <div className=" ">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="w-full md:w-1/3 p-4">
              <img
                src="\assets\images\devops\streamImg2.avif"
                alt="Streaming dashboard visualization"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>

            <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon13.png"
                  alt="Automated Testing Icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Ensure high-quality streaming with automated testing for
                    smooth video playback and uninterrupted user experiences.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon14.png"
                  alt="Deployment Icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Deliver seamless updates to keep your streaming platform at
                    peak performance during high-demand events.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon15.png"
                  alt="Version Control Icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Manage feature rollouts efficiently and resolve issues
                    quickly with integrated version control systems.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon16.png"
                  alt="Scalability Icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Scale resources dynamically to ensure uninterrupted
                    streaming during peak demand.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="rounded-3xl">
          <div className="text-center mb-5 mt-5">
            <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
              Streaming Solutions We Deliver
            </h2>
          </div>

          <div className=" p-6 ">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Item 1 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Live Streaming</h3>
                <p className="text-lg">
                  Seamlessly broadcast live events to audiences worldwide with
                  our reliable and scalable live streaming solutions.
                </p>
              </div>

              {/* Item 2 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">On-Demand Streaming</h3>
                <p className="text-lg">
                  Provide your audience with high-quality on-demand content
                  delivery with adaptive streaming technologies.
                </p>
              </div>

              {/* Item 3 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">
                  Multi-Device Compatibility
                </h3>
                <p className="text-lg">
                  Ensure seamless streaming experiences across various devices,
                  including smartphones, tablets, smart TVs, and desktops.
                </p>
              </div>

              {/* Item 4 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">
                  Content Delivery Optimization
                </h3>
                <p className="text-lg">
                  Optimize content delivery with CDN integration to reduce
                  buffering and ensure uninterrupted playback.
                </p>
              </div>

              {/* Item 5 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Video Analytics</h3>
                <p className="text-lg">
                  Leverage advanced analytics to track user engagement and
                  optimize your streaming platform for better performance.
                </p>
              </div>

              {/* Item 6 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Secure Streaming</h3>
                <p className="text-lg">
                  Protect your content with advanced encryption, DRM solutions,
                  and secure streaming protocols.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="p-6 sm:p-8 md:p-12 lg:p-16 w-full rounded-3xl">
          <div className="text-center mb-8">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Expert Streaming Platform Consulting and Support
            </h2>
          </div>

          <div className="mb-8">
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              At Ayanshtech, we specialize in delivering cutting-edge streaming
              platform solutions tailored to meet your business needs. From live
              event broadcasting to on-demand content delivery, our team ensures
              high-quality streaming experiences for your audience.
            </p>
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              Our key offerings include:
            </p>
            <ul className="list-disc pl-8 sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto">
              <li>Live and on-demand streaming solutions</li>
              <li>
                Multi-device compatibility and user experience optimization
              </li>
              <li>Content delivery with CDN integration</li>
              <li>Advanced video analytics and reporting</li>
              <li>Secure streaming with encryption and DRM</li>
            </ul>
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              Ayanshtech’s streaming platform experts bring deep expertise in
              state-of-the-art technologies and industry best practices. We
              deliver innovative solutions to ensure your content reaches the
              right audience, at the right time, without compromise.
            </p>
          </div>

          <div className="text-center">
            <button
              onClick={scrollToContact}
              className="bg-blue-600 hover: hover:text-blue-600 hover:border hover:border-blue-600 text-white font-semibold py-3 px-6 rounded-full text-lg transition duration-300"
            >
              Schedule a Free Consultation Today!
            </button>
          </div>
        </div>

        <div className="max-w-3xl mx-auto p-6 py-20 w-full ">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
            FAQs
          </h2>
          {OttFaqs.map((faq, index) => (
            <div key={index} className="border-b ">
              <button
                onClick={() => toggleFAQ(index)}
                className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                  actIndex === index
                    ? "bg-blue-600 text-white px-5 rounded-2xl"
                    : ""
                }`}
              >
                <span className="text-lg">{faq.question}</span>
                <span className="text-2xl">
                  {actIndex === index ? "-" : "+"}
                </span>
              </button>
              {actIndex === index && (
                <div className="p-4 text-gray-700">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>

        <div id="contact-section">
          {" "}
          <ContactUs />
        </div>
      </div>
    </>
  );
};

export default StreamingPlatfom;
